import React, {useContext, useState} from 'react';
import './ServerPopup.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Button} from "../../elements/button/Button";
import {PopupImage} from "../../elements/popup-image/PopupImage";
import {getSafeTranslation} from "../../../helpers/localization.helper";
import {TranslationsContext} from "../../../contexts/translations-context";
import * as Utils from "../../../helpers/format.helper";
import {DrawerDescription} from "../../elements/drawer-description/DrawerDescription";

export const SERVER_POPUP = 'SERVER_POPUP';

export const Server = ({title, description, image, onDoneClick, onExternalLinkClick, onRestaurantLinkClick, onMenuEntryLinkClick, onOverlayClick}) => {
	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={title}
		rightControl={<Button onClick={onDoneClick}
													isAutoWidth={false}>{getSafeTranslation('ServerPopup.doneButtonCaption', translations)}</Button>}
		onOverlayClick={onOverlayClick}
	>
		<div className="server-popup">
			{
				image &&
				<div className="server-popup__image">
					<PopupImage src={image}/>
				</div>
			}
			<div className="server-popup__description">
				<DrawerDescription text={description} isFullSize={true} onExternalLinkClick={onExternalLinkClick}
													 onRestaurantLinkClick={onRestaurantLinkClick} onMenuEntryLinkClick={onMenuEntryLinkClick}/>
			</div>

		</div>

	</DrawerPopup>
}
